import { MyContext } from "../../pages/Funnel";
import DialogDemo from "../../main/funnel/dialog/Dialog";
import React, { useContext } from "react";
import clsx from "clsx";

const PrimaryBtn = ({ children, width, padding ,className }) => {
  const state = useContext(MyContext);
  return (
    // <DialogDemo>
    <button
      onClick={() => window.open(state?.state.razor)}
      style={{
        width: width,
        padding: padding,
        backgroundColor: state?.state.color,
      }}
      className={clsx(
        "bg-primary animate-pulse rounded-md text-white font-normal  text-base  max-sm:text-xs py-[0.7rem] px-8 w-fit",
        className
      )}>
      {children}
    </button>
    // </DialogDemo>
  );
};

export default PrimaryBtn;
